import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { config } from '@app/app.config';
import { Observable } from 'rxjs';
import { AuthService } from '@app/auth/auth.service';

export interface Permission {
    name: string;
}

@Injectable({
    providedIn: 'root'
})
export class UsersService {
    constructor(
        private http: HttpClient,
        private authService: AuthService
    ) {}

    getPermissions(): Observable<Permission[]> {
        return this.http
            .get<Permission[]>(
                config.httpURL + `/api/get-user-permissions`,
                { headers: { Authorization: `Bearer ${this.authService.getAccessToken()}` }}
            );
    }

    getUsers(): Observable<UserDTO[]> {
        return this.http
            .get<UserDTO[]>(
                config.httpURL + '/api/users',
                { headers: { Authorization: `Bearer ${this.authService.getAccessToken()}`}}
            );
    }
}

export interface UserDTO {
    id: number,
    email: string;
    username: string;
    firstName: string;
    lastName: string;
    role: string;
  }